/**
 * Helps you to get the proper link of the different projects
 */
export default class ProjectLinks {
    /**
     * Accepts a project name as a string
     * Returns an URL based on the environment 
     * 
     * @param {String} project - project name
     * @param {String=} env - environment name (optional)
     * @returns url
     */
    static getProjectLink(project, env = process.env.ENVIRONMENT) {
        switch (project) {
            case 'connect':
                switch (env) {
                    case 'local':
                        return 'https://lcl-connect.easymarkets.com:3000';
                    case 'prp':
                        return 'https://prpconnect.easymarkets.com';
                    case 'prod':
                    default:
                        return 'https://connect.easymarkets.com';
                }
            default:
                return location.origin;
        }
    }
}